<template lang="pug">
v-simple-table.rounded-lg.videoTable(flat)
  template(v-slot:default='')
    //-thead
      tr
        th.text-left
          | Bild
        th.text-left
          | Name
        th.text-left
          | Categories
        th.text-left
          | Download
        th.text-left
          | 
    tbody
      tr(v-for='(video, i) in videos', :key='video.id')
        td(width="160") 
          v-img.my-2.primary.rounded-lg(:src='getThumbnailUrl(video.id, video.token, video.element)' :aspect-ratio="16 / 9" color="primary")
            template(v-slot:default v-if="video.status == VideoStatus.PROCESSING || video.status == VideoStatus.PENDING")
              v-row.play-overlay.fill-height.ma-0(align='center' justify='center')
                v-progress-circular(indeterminate :width="1" :size="20" color="white")
        td.truncate
          v-list-item-content
            v-list-item-title
              router-link(:to="{name: video.element == VideoElement.CLIP ? 'clip':'motion', params: {videoId: video.id }}") 
                strong {{video.title}}
            v-list-item-subtitle {{dateAgo(video.createdAt)}}
          //- strong {{video.title}}
        td.d-none.d-md-table-cell(width="200")
          v-chip.mr-2(label small color="accent" v-for="(category, index) in video.categories.items" :key="index") {{ category.category.title }}                
        td.d-none.d-md-table-cell(width="60")
          div(v-if="video.element === VideoElement.MOTION")
            
            ShareMotionDialog(:video="video"  :small="true" v-if="hasFeatureAccess(RestrictedFeature.SOCIAL_CONNECTION_YOUTUBE)")
            VideoDownloadButton(:video="video" :small="true" ) 
          VideoAddToMotionCreator(:video="video" v-else)
        td(width="60")
          v-btn(text color="accent" :to="{name: video.element == VideoElement.CLIP ? 'clip':'motion', params: {videoId: video.id }}")  
            span.d-none.d-sm-table-cell {{video.element == VideoElement.CLIP ? $t('clips.goTo') : $t('motions.goTo')}}
            v-icon mdi-chevron-right

</template>
<script>
import date from "@/utils/date";
import urlFormat from "@/utils/urlFormat";
import { VideoStatus, VideoElement, RestrictedFeature } from "../../models";
import { hasFeatureAccess } from "@/utils/featureAccess";
import VideoStatusIcons from "./VideoStatusIcons";
import VideoMotionCardActions from "./VideoMotionCardActions";
import VideoDownloadButton from "@/components/video/VideoDownloadButton";
import VideoAddToMotionCreator from "@/components/video/VideoAddToMotionCreator";
import ShareMotionDialog from "@/components/video/ShareMotionDialog";
export default {
  name: "VideoTableItem",
  components: {
    VideoStatusIcons,
    VideoMotionCardActions,
    VideoDownloadButton,
    VideoAddToMotionCreator,
    ShareMotionDialog,
  },
  props: ["videos"],
  data() {
    return {
      VideoStatus,
      VideoElement,
      RestrictedFeature,
    };
  },
  methods: {
    ...date,
    ...urlFormat,
    hasFeatureAccess,
    // goTo(video) {
    //   this.$router.push({
    //     name: video.element == this.VideoElement.CLIP ? "clip" : "motion",
    //     params: { videoId: video.id },
    //   });
    // },
  },
};
</script>
<style lang="sass" scoped>
// @import '@/assets/style/main'
.videoTable
  overflow: hidden
tbody
     tr:hover
        background-color: transparent !important
.truncate
  max-width: 1px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
